import { loadElementLazyImage } from './helpers/lazy-load'
import { updateSmoothScroll } from './scroll-smoother'
import { getUrlParameter } from './helpers/helper-functions'


// Filter posts
let filterPosts = $('.js-posts-filter')
if (filterPosts.length){

    filterPosts.each((i, block)=> {

        let currentRequest = null;
        let $block = $(block)
        let $catButtons = $block.find('.js-cat-b')
        let $loadMore = $block.find('.js-load-more')
        let $activeCat = $block.find('.js-active-cat')
        let $container = $block.find(".js-results")
        let $progressBar = $block.find(".js-progress")
        let $progressText = $block.find('.js-progress-text')
        let taxonomyName = $block.data('taxonomy')
        let postType = $block.data('post-type')
        let postsPerPage = $block.data('posts-per-page')
        let lastCat = ''

        $catButtons.click(function(){
            changeActive($(this))
            loadPosts()
        });

        $loadMore.click(function(){
            loadPosts(true)
        });

        $(document).ready(function () {
            let loadCat = getUrlParameter($('body').data('page-url'), 'category')
            if (loadCat){
                $block.find('.js-cat-b[data-term-id="'+ loadCat +'"]').click()
            } else {
                $block.find('.js-cat-b.active').first().click()
            }
        });

        const changeActive = $this => {
            let termId = $this.data('term-id')
            $catButtons.removeClass('active')
            $catButtons.each((i, el)=> {
                if ($(el).data('term-id') === termId) $(el).addClass('active')
            })
            $activeCat.data('active-cat', termId)
        }

        const loadPosts = (loadMore = false) => {
            let offset = 0
            let termId = $activeCat.data('active-cat')
            if (!termId) termId = ''

            if (loadMore)
                offset = $container.children().length

            currentRequest = $.ajax({
                type: "GET",
                url: ajaxurl,
                data: {
                    action: 'filter_posts',
                    category: termId,
                    offset: offset,
                    taxonomy: taxonomyName,
                    postType: postType,
                    postsPerPage: postsPerPage
                },
                beforeSend: function () {
                    if (currentRequest != null) {
                        currentRequest.abort()
                    } else {
                        $loadMore.parent().addClass('loading')
                    }

                    if (lastCat !== termId) $($container).find('.post-el').fadeOut()
                },
                success: function (html) {
                    if (loadMore) {
                        $container.append(html);
                    } else {
                        $container.html(html);
                    }

                    // load lazy images
                    loadElementLazyImage($container.find('.lazy'))

                },
                fail: function () {
                    // console.log('Partners ajax request failed')
                },
                complete: function () {
                    currentRequest = null
                    let current = $container.children().length
                    let total = $block.find('.js-cat-b.active').first().data('total')

                    if (current >= total) {
                        $loadMore.addClass('button--disabled')
                        $loadMore.prop('disabled', true);
                    } else {
                        $loadMore.removeClass('button--disabled')
                        $loadMore.prop('disabled', false)
                    }

                    updateProgressBar($progressBar, current, total)

                    updateSmoothScroll()

                    $loadMore.parent().removeClass('loading')

                    lastCat = termId
                }
            });
        }

        const updateProgressBar = ($progressBar, current, total) => {
            let percentage = (current / total) * 100

            if ($progressText.length && $progressText) {
                $progressText.text($progressText.data('progress-text').replace('@', current).replace('$', total))
            }

            $progressBar.css("width", percentage.toString() + '%');
        }




    }) // end filter posts foreach
}
